var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterBird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.02,
    height: 12.201,
    viewBox: "0 0 15.02 12.201",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter-bird",
    d: "M15.02,1.445A6.24,6.24,0,0,1,13.48,3.036q.009.176.009.4a8.851,8.851,0,0,1-1.461,4.845,9.361,9.361,0,0,1-1.764,2.007A7.863,7.863,0,0,1,7.8,11.681a8.988,8.988,0,0,1-3.08.52A8.577,8.577,0,0,1,0,10.816a6.663,6.663,0,0,0,.735.043,6.041,6.041,0,0,0,3.827-1.32,2.99,2.99,0,0,1-1.789-.615A3.029,3.029,0,0,1,1.685,7.4a3.08,3.08,0,0,0,1.391-.052A3,3,0,0,1,1.308,6.286a2.981,2.981,0,0,1-.7-1.958V4.289A3.041,3.041,0,0,0,2,4.675a3.061,3.061,0,0,1-1-1.1A3.007,3.007,0,0,1,.63,2.111,3.027,3.027,0,0,1,1.047.563,8.773,8.773,0,0,0,3.856,2.837,8.563,8.563,0,0,0,7.4,3.783a3.013,3.013,0,0,1-.081-.7A2.968,2.968,0,0,1,8.219.9a3.083,3.083,0,0,1,4.428.069A6.137,6.137,0,0,0,14.6.224a2.979,2.979,0,0,1-1.353,1.705,6.158,6.158,0,0,0,1.77-.484Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterBird);
export default __webpack_public_path__ + "static/media/twitter-bird.a6ec7917cb5c3fda0aa421b79005bf99.svg";
export { ForwardRef as ReactComponent };